import { createResource } from 'solid-js';
import { api, Me } from './api';
import { session } from './auth';

export const [me, { refetch: refetchMe }] = createResource(() => session()?.access_token, () => api<Me>('/me'));
export const isOperator = () => !!me()?.bindings.some((b) => b.role === 'operator');
